var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"meter orange nostripes"},[_c('span',{staticClass:"progressbar_background"}),_c('span',{style:(_vm.styleObject)})])])
}
var staticRenderFns = []

export { render, staticRenderFns }